module.exports = __webpack_public_path__ + "static/app.564830b1.png";